import dayjs from "dayjs";
import _ from "lodash";

/**
 * 日期选择器特有选项
 * @param {*} DateType 0--自然日（明天之后日期被禁用）；1--扎账日（今天之后日期被禁用）
 * @param {*} dayLimit 日期范围
 * @param {*} shortcuts 日期快捷选项
 * @param {*} type 日期选择器类型，默认daterange
 * @param {*} pickDisabled 是否进行选择限制
 */
export function eleDatePickerInit(options = {}) {
  let { dayLimit, shortcuts, type, pickDisabled, DateType } = options;
  let dayNum = dayLimit || 91;
  let monthNum = Math.max(0, Math.floor(dayNum / 30) - 1);
  let shortcutsArry = shortcuts || [7, 30, 90];
  let pickerType = type || "daterange";
  let dateType = 0;
  let _minTime = null;
  let _maxTime = null;
  let pickerOptions = {
    /**
     * 选中日期后会执行的回调
     * 只有当 daterange 或 datetimerange 才生效
     * @param {*} time
     */
    onPick(time) {
      const { maxDate, minDate } = time;
      if (!maxDate) {
        // 只选择了一个时间
        if (type === "monthrange") {
          // 当为月份范围时，1. 不同的月份天数不同，2. 一月至三月表示法 1-3，所以月份需要减一
          _minTime = new Date(+minDate).setMonth(minDate.getMonth() - monthNum);
          _maxTime = new Date(+minDate).setMonth(minDate.getMonth() + monthNum);
        } else {
          const timeRange = dayNum * 24 * 60 * 60 * 1000;
          _minTime = minDate.getTime() - timeRange; // 最小时间
          _maxTime = minDate.getTime() + timeRange; // 最大时间
        }
      } else {
        _minTime = _maxTime = null;
      }
    },
    /**
     * 日期组件初始化切换、onpick触发
     * @param {*} time
     */
    disabledDate(time) {
      let boolRanger = false; //日期范围判定
      let boolDateType = false; //自然日、扎账日判定
      if (_maxTime && _minTime) {
        boolRanger = time.getTime() < _minTime || time.getTime() > _maxTime;
      }
      if (dateType == 0) {
        boolDateType =
          time.getTime() - 24 * 60 * 60 * 1000 > Date.now() - 8.64e7;
      } else {
        boolDateType =
          time.getTime() - 48 * 60 * 60 * 1000 > Date.now() - 8.64e7;
      }
      return boolRanger || boolDateType;
    },
    cellClassName(time) {
      if (dateType == 1) {
        const tommrowDate = dayjs().add(1, "day").format("YYYY-MM-DD");
        if (dayjs(time).isSame(tommrowDate, "day")) {
          // 扎账日最后一天日期className
          return "accounting_end_date";
        }
      }
    },
  };
  if (pickDisabled) {
    pickerOptions = {};
  }
  if (pickerType == "date") {
    pickerOptions = {
      ...pickerOptions,
      shortcuts: shortcutsArry.length === 0 ? null : shortcutsArry, // 在不需要快捷选择时，隐藏掉快捷选择
    };
  }
  if (pickerType == "daterange") {
    pickerOptions = {
      ...pickerOptions,
      shortcuts:
        shortcutsArry.length === 0 ? null : setShortcuts(shortcutsArry), // 在不需要快捷选择时，隐藏掉快捷选择
    };
  }
  return pickerOptions;
}
//为datepicker设置快捷选项
function setShortcuts(shortcutsArry) {
  const chnNumChar = {
    0: "零",
    1: "一",
    2: "二",
    3: "三",
    4: "四",
    5: "五",
    6: "六",
    7: "七",
    8: "八",
    9: "九",
  };
  let shortcuts = [];
  shortcutsArry.forEach((day) => {
    let obj = {};
    let text,
      num = day;
    if (Object.prototype.toString.call(day) == "[object Object]") {
      text = day.text;
      num = day.value;
    } else {
      if (day >= 30 && day % 30 == 0) {
        text = "最近" + chnNumChar[Math.floor(day / 30)] + "个月";
      } else if (day >= 7 && day % 7 == 0) {
        text = "最近" + chnNumChar[Math.floor(day / 7)] + "周";
      } else {
        text = "最近" + chnNumChar[day] + "天";
      }
    }
    obj.text = text;
    obj.onClick = (picker) => {
      const end = new Date();
      const start = new Date();
      start.setTime(start.getTime() - 3600 * 1000 * 24 * num);
      picker.$emit("pick", [start, end]);
    };
    shortcuts.push(obj);
  });
  return shortcuts;
}

export const getCurDate = function (action) {
  let date = new Date();
  let year = date.getFullYear();
  let month = date.getMonth() + 1;
  month = month < 10 ? "0" + month : month;
  let day = date.getDate();
  day = day < 10 ? "0" + day : day;
  let cur_time = year + "-" + month + "-" + day;
  let cur_month = year + "-" + month;
  if (action == "time") {
    //时分秒
    let hour = date.getHours();
    let minutes = date.getMinutes();
    let seconds = date.getSeconds();
    hour = hour < 10 ? "0" + hour : hour;
    minutes = minutes < 10 ? "0" + minutes : minutes;
    seconds = seconds < 10 ? "0" + seconds : seconds;
    let time = hour + ":" + minutes + ":" + seconds;
    cur_time = cur_time + " " + time;
  }
  return cur_time;
};

// 防抖动
export function debounce(func, delay = 300, isImmediate = false) {
  let timer = null;
  let flag = true;

  if (isImmediate) {
    return function (...args) {
      clearTimeout(timer);
      if (flag) {
        func.apply(this, args);
        flag = false;
      }
      timer = setTimeout(() => {
        flag = true;
      }, delay);
    };
  } else {
    return function (...args) {
      clearTimeout(timer);
      timer = setTimeout(() => {
        func.apply(this, args);
      }, delay);
    };
  }
}


// 高亮搜索结果
export function highlight(text, words, tag) {
	// 默认的标签，如果没有指定，使用span
	tag = tag || 'span'
	let re
	//匹配每一个特殊字符 ，进行转义
	let specialStr = ['*', '.', '?', '+', '$', '^', '[', ']', '{', '}', '|', '\\', '(', ')', '/', '%']

	specialStr.forEach(ele => {
		if (words.indexOf(ele) != -1) {
			words = words.replace(new RegExp('\\' + ele, 'g'), '\\' + ele)
		}
	})

	//匹配整个关键词
	re = new RegExp(words, 'g')

	if (re.test(text)) {
		text = text.replace(re, '<' + tag + ' class="highlight">$&</' + tag + '>')
	}
	return text
}